import { Observable } from 'rxjs';

export enum AssetVerificationProviderId {
  FORMFREE = '1',
  FINICITY = '2',
}

export type AssetVerificationProviderVersion = 'v1' | 'v2';

export type AssetVerificationEventType = 'success' | 'cancel' | 'error' | 'loaded' | 'route' | 'user';

export interface AssetVerificationEvent {
  type: AssetVerificationEventType;
  data?: unknown;
}

export interface AssetVerificationLaunchOptions {
  selector?: string;
  overlay?: string;
}

export interface ProviderDetectionResult {
  providerId: AssetVerificationProviderId;
  version: AssetVerificationProviderVersion;
  providerName: 'Formfree' | 'Finicity';
}

export interface AssetVerificationProvider {
  isLoaded(): boolean;

  launch(url: string, options?: AssetVerificationLaunchOptions): Observable<AssetVerificationEvent>;

  destroy(): void;

  getEvents(): Observable<AssetVerificationEvent>;
}

export function detectProviderFromUrl(loginUrl: string): ProviderDetectionResult {
  const lowerUrl = loginUrl?.toLowerCase() || '';

  if (lowerUrl.includes('finicity.com')) {
    const version: AssetVerificationProviderVersion = lowerUrl.includes('connect2') ? 'v2' : 'v1';
    return {
      providerId: AssetVerificationProviderId.FINICITY,
      version,
      providerName: 'Finicity',
    };
  }

  return {
    providerId: AssetVerificationProviderId.FORMFREE,
    version: 'v1',
    providerName: 'Formfree',
  };
}

export function isFinicityProvider(providerId: string): boolean {
  return providerId === AssetVerificationProviderId.FINICITY;
}

export function isFormfreeProvider(providerId: string): boolean {
  return providerId === AssetVerificationProviderId.FORMFREE;
}
